import { Box, Flex, FlexProps } from '@wegroup/design-system';
import React from 'react';
import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';

const ProgressBar: React.FC<React.PropsWithChildren<FlexProps>> = ({
  ...props
}) => {
  const lastPosition = useFlowsSelector(
    (state) => state.flowsMetaData.lastPosition,
  );
  const groups = useFlowsSelector((state) => state.flows.questionnaire.groups);

  return (
    <Flex w="100%" h="1" {...props}>
      <Box
        pos="absolute"
        left="0"
        bottom="0"
        w={`${(100 / groups.length) * (lastPosition + 1)}%`}
        h="100%"
        bg="primary.500"
        transition="width 0.2s"
        borderTopRightRadius="full"
        borderBottomRightRadius="full"
      />
      <Box w="100%" h="100%" bg="gray.50" bottom="0" left="0" right="0" />
    </Flex>
  );
};

export default ProgressBar;
